import {Directive, EventEmitter, Input, Output} from "@angular/core";

@Directive()
export class AddRowActionComponent {
    @Output() availabilityChanged: EventEmitter<any> = new EventEmitter();

    private _available: boolean = true;

    constructor() {
    }

    @Input() get available(): boolean {
        return this._available;
    }

    set available(value: boolean) {
        this._available = value;
        this.availabilityChanged.emit();
    }

    public click(): void {
    };
}
